

export interface IBreadcrumb {
  id: string;
  path: string;
  label: string;
}

export const changeBreadcrumbs = (breadcrumbs: IBreadcrumb[]) => {
  dispatchEvent(new CustomEvent('CHANGE_BREADCRUMBS_EVENT', {
    detail: breadcrumbs
  }));
};

